<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (!isModal) {
        <ion-back-button defaultHref="/kegs"></ion-back-button>
      }
    </ion-buttons>
    <ion-buttons slot="end">
      @if (isModal) {
        <ion-button (click)="closeModal()"> Close</ion-button>
      }
    </ion-buttons>
    <ion-title>
      New Keg
    </ion-title>
  </ion-toolbar>
</ion-header>
@if (barId()) {
  @if (barId()) {
    <ion-content class="ion-padding">
      <form [formGroup]="form" (ngSubmit)="save()">
        <ion-card class="ion-no-padding ion-no-margin">
          <ion-card-content class="ion-no-padding">
            <ion-item lines="none">
              <ion-input label="Name" labelPlacement="floating" formControlName="name" #nameInput autofocus data-testid="new-keg-name"></ion-input>
              @if (form.controls['name'].invalid && formSubmitted) {
                <ion-note slot="error">Name is required</ion-note>
              }
            </ion-item>
          </ion-card-content>
        </ion-card>
        <div class="ion-display-flex ion-flex-column ion-flex-md-row ion-padding-top">
          <div>
            <ion-button color="success" class="ps-w-100" (click)="save()" data-testid="new-keg-save">
              Next
              <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
            </ion-button>
          </div>
        </div>
      </form>
    </ion-content>
  }
}
